import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import VideocamIcon from "@mui/icons-material/Videocam";

/**
 * Playback video surface.
 * Renders a real <video> when streaming; otherwise the camera placeholder.
 */
const PlaybackVideoArea = ({
  videoRef,
  hasStream = false,
  status = "idle",
}) => {
  const showPlaceholder = !hasStream;
  const hasError = typeof status === "string" && status.startsWith("Error");
  const isLoading =
    hasStream &&
    !hasError &&
    status !== "playback · playing" &&
    status !== "paused";

  return (
    <Box
      sx={{
        width: "100%",
        aspectRatio: "225.81 / 152.68",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        backgroundColor: "#000",
        overflow: "hidden",
      }}
    >
      {/* No autoPlay: the stream buffer controller starts playback once it has
          a cushion, otherwise the element rides the buffer edge and stutters. */}
      <video
        ref={videoRef}
        playsInline
        muted
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "contain",
          backgroundColor: "#000",
          visibility: hasStream ? "visible" : "hidden",
        }}
      />

      {showPlaceholder && (
        <VideocamIcon sx={{ fontSize: 68, color: "rgba(255,255,255,0.82)", zIndex: 1 }} />
      )}

      {isLoading && (
        <Typography
          sx={{
            position: "absolute",
            left: 12,
            bottom: 10,
            zIndex: 2,
            fontSize: 11,
            color: "rgba(255,255,255,0.75)",
          }}
        >
          {status}
        </Typography>
      )}

      {hasError && (
        <Typography
          sx={{
            position: "absolute",
            left: 12,
            right: 12,
            bottom: 10,
            zIndex: 2,
            fontSize: 11,
            color: "#ff8a80",
            textAlign: "center",
          }}
        >
          {status}
        </Typography>
      )}

    </Box>
  );
};

PlaybackVideoArea.propTypes = {
  videoRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  hasStream: PropTypes.bool,
  status: PropTypes.string,
};

export default PlaybackVideoArea;
